import { ErrorBoundary as ErrorBoundaryBase } from '@kelbongoo/shared-client-react-v2/dist/components/ErrorBoundary';

export const ErrorBoundary = ErrorBoundaryBase({});
